import React from 'react';

import {StudyType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getStudyTypeText} from 'studies/TypedStudyUtils';
import FormGroup from 'ui-library/bs/FormGroup';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import Menu from 'ui-library/menus/Menu';
import SearchableMenu from 'ui-library/menus/SearchableMenu';

export interface StudyTypeOption {
  studyType: StudyType;
  name: string;
}

interface StudyTypeSelectorProps {
  displayName: string;
  onChangeStudyType: (studyType: StudyTypeOption | null) => void;
  selectedStudyType: StudyTypeOption | null;
  studyTypes: Array<StudyType>;
}

function getStudyTypeOptions(
  studyTypes: Array<StudyType>
): Array<{value: StudyTypeOption | null; name: string}> {
  return [
    {value: null, name: 'All'},
    ...studyTypes
      .map((studyType) => ({
        value: {studyType, name: getStudyTypeText(studyType)},
        name: getStudyTypeText(studyType),
      }))
      .sort((a, b) => a.name.localeCompare(b.name)),
  ];
}

export function StudyTypeSelector(props: StudyTypeSelectorProps): JSX.Element {
  const studyTypeOptions = getStudyTypeOptions(props.studyTypes);
  return (
    <FormGroup dataTestAttrs={{component: 'StudyTypeSelector', element: 'root'}}>
      <FieldLabel label="Study type" />
      <SelectDropdown
        displayName={props.displayName}
        menu={
          <SearchableMenu
            onSelect={props.onChangeStudyType}
            selectedValue={props.selectedStudyType}
            width={Menu.WIDTHS.MEDIUM}
            optionDatas={studyTypeOptions}
          />
        }
      />
    </FormGroup>
  );
}
